import axios, { AxiosRequestConfig } from 'axios'

import { computed } from 'vue'
import config from '../config'
import { getDrRegionHeader } from '@/util/region'
import { setupAutoUpdateToken } from '@gohighlevel/ghl-proposals-common/src/utils/setupToken'
import { useAppStore } from '@/store/app'
import { useRoute } from 'vue-router'

const isNotProduction = () => process.env.NODE_ENV !== 'production'

const route = computed(() => useRoute())
const getHeader = (isMobilePreview = false) => {
  return {
    channel: 'APP',
    source: isMobilePreview ? 'MOBILE_USER' : 'WEB_USER',
    version: '2021-07-28',
    // AU DR: only present when the recipient link carried `region=<non-us>`.
    ...getDrRegionHeader(),
    ...(isNotProduction() && route.value && route.value.query && route.value.query['developer_version']
      ? { developer_version: route.value.query['developer_version'] }
      : {}),
  }
}

export const requests = (host?: string) => {
  const baseUrl = host || config.restApiUrl
  const axiosInstance = axios.create({
    baseURL: baseUrl,
    headers: getHeader(),
  })

  return axiosInstance
}

export const privateRequests = (host?: string, isMobilePreview = false) => {
  const baseUrl = host || config.restApiUrl
  const axiosInstance = axios.create({
    baseURL: baseUrl,
    headers: getHeader(isMobilePreview),
  })

  axiosInstance.interceptors.request.use(
    // eslint-disable-next-line
    // @ts-expect-error
    async (requestConfig: AxiosRequestConfig) => {
      try {
        if (isMobilePreview) {
          // Get token from window.getMobileData() for mobile preview
          const mobileData = window.getMobileData?.() || {}
          const mobileToken = mobileData.mobileToken || ''
          // eslint-disable-next-line
          // @ts-expect-error
          requestConfig.headers['token-id'] = mobileToken
        } else {
          const store = useAppStore()
          // eslint-disable-next-line
          // @ts-expect-error
          requestConfig.headers['token-id'] = store.tokenId
        }
      } catch (e) {
        console.error(e)
      }
      return requestConfig
    }
  )
  // Only setup auto token update for non-mobile preview (uses postmate handshake)
  if (!isMobilePreview) {
    setupAutoUpdateToken(axiosInstance)
  }
  return axiosInstance
}
